import React, { useCallback, useContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  MdOutlineDashboard,
  MdDashboard,
  MdOutlineSdCardAlert,
  MdSdCardAlert,
} from "react-icons/md";
import { PiUsersThreeBold, PiUsersThreeFill } from "react-icons/pi";
import {
  LuPencil,
  LuKeyRound,
  LuTrash,
  LuLogOut,
  LuChevronRight,
  LuPanelRightClose,
  LuPhoneCall,
} from "react-icons/lu";

import { Layout, Menu, Select, DatePicker, Breadcrumb } from "antd";
const { Header, Content, Sider } = Layout;
import sidebarlogo from "@/assets/sidebarlogo.svg";
import { removeToken } from "@/utils/auth";
import LogOutModal from "@/Shared/LogOut/LogOutModal";
import ls from "store2";
import { getUserDetails, getDeletedUser } from "@/api/Users";
import ChnaePasswordModal from "@/Components/ChangePasswordModal/index";
import CreateAdminSupportAgent from "@/Components/PubTable/CreateAndEditUsers";
import * as SidebarContext1 from "@/Context/CustomUsertable";
import AdminSupportAgentTable from "@/Components/PubTable/AdminSupportAgentTable";
import GetRecentlyDeletedUserColumn from "./utiles";
import SearchInput from "@/Shared/Search/SearchInput";
import Sort from "@/Shared/sort/Sort";
import { useCountStore } from "@/store/index";
import { getToken, setToken } from "@/utils/auth";
import { jwtDecode } from "jwt-decode";
import Loader from "@/Components/Loader";
import { SidebarContext } from "@/Context/CustomContext";
import RoleSort from "@/Shared/sort/RoleSort";
import { LuPackage } from "react-icons/lu";
import { PiPackageFill } from "react-icons/pi";
import { Button, Dropdown, Flex } from "antd";
import { AiOutlineTool, AiFillTool } from "react-icons/ai";
import { RiExchangeDollarLine, RiMoneyDollarCircleFill } from "react-icons/ri";
import { unsubscribeFromMqtt } from "@/api/deviceReports";
import { getTokenToCall } from "@/api/deviceCall";
const RoleBaseSortItem = {
  super_admin: [
    "All Users",
    "Distributors",
    "Offices",
    "Monitoring Stations",
    "Sales Agents",
    "Nursing Homes",
    "Nurses",
    "Support Agents",
    "End Users",
  ],
  distributor: ["All Users", "Offices", "Sales Agents"],
};
const RoleMapping = {
  Distributors: "distributor",
  Offices: "office",
  "Monitoring Stations": "monitoring_station",
  "Sales Agents": "sales_agent",
  "Nursing Homes": "nursing_home",
  Nurses: "nurse",
  "Support Agents": "support_agent",
  "End Users": "end_user",
};
const DashboardLayout = () => {
  const navigate = useNavigate();
  // const [activeMemu, setActiveMenu] = useState("");
  const [edit, setEdit] = useState(false);
  const [resetModal, setResetMOdal] = useState(false);
  const [loader, setLoader] = useState(false);
  const {
    rolesFormatter,
    isLogin,
    setActiveMenu,
    activeMemu,
    setDailyRepDate,
  } = useContext(SidebarContext);
  const location = useLocation();
  const currentPath = location.pathname;
  const [toggleSidebar, setToggleSidebar] = useState(true);
  const [toggleMainSidebar, setToggleMainSidebar] = useState(false);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(null);
  const role = ls.get("role");
  const user = ls.get("user");
  // const elderlyDetails = ls.get("elderly_details");
  const [elderlyDetails, setElderlyDetails] = useState([]);
  const data = ["Time", "Name"];
  const [search, setSearch] = useState("");
  const rootRole = ls.get("rootRole");
  const mainRole = ls.get("mainRole");
  const [query, setQuey] = useState({});
  const [selected, setSelected] = useState("Time");
  const [selectedRole, setSelectedRole] = useState("All Users");
  const [page, SetPage] = useState({
    page: 1,
    limit: 10,
  });
  const [total, SetTotal] = useState(0);

  const [recentlyDeletedUsers, setRecentlyDeletedUsers] = useState([]);
  const deletedUserColumns = GetRecentlyDeletedUserColumn();
  const { setStoreRole, setUser } = useCountStore();
  const elderlyProfilePath =
    /^#\/supporter\/elderlies\/elderly-profile\/\d+(\/?|\?.*)$/;
  const pathWithoutDomain = currentPath.split("#")[1] || "";
  if (!isLogin) {
    window.location.href = "/";
  }

  async function getUsers() {
    getUserDetails({
      id: user._id,
    })
      .then((res) => {
        if (res) {
          setUserData(res.data);
        }
      })
      .catch((err) => {
        ls.clear();
        window.location.href = "/";
        console.log(err);
      });
  }

  const NAV_CONFIG = {
    super_admin: [
      {
        key: "1",
        label: "dashboard",
        ActiveIcon: MdDashboard,
        InactiveIcon: MdOutlineDashboard,
        link: "/super-admin/dashboard",
        matchPaths: ["/super-admin/dashboard"],
      },
      {
        key: "2",
        label: "users",
        ActiveIcon: PiUsersThreeFill,
        InactiveIcon: PiUsersThreeBold,
        link: "/super-admin/users",
        matchPaths: [
          "/super-admin/users",
          "/super-admin/users/distributor-deal/*",
          "/super-admin/users/distributor-deal/details/*",
          "/super-admin/users/distributor-deal/new-deal/*",
        ],
        innerPages: {
          "/distributor-deal/:id": "Distributor Deal",
          "/distributor-deal/details/:id": "Deal Details",
          "/distributor-deal//new-deal/:id": "New Deal",
        },
      },
      {
        key: "3",
        label: "refunds request",
        ActiveIcon: RiMoneyDollarCircleFill,
        InactiveIcon: RiExchangeDollarLine,
        link: "/super-admin/refunds-request",
        matchPaths: ["/super-admin/refunds-request"],
      },
    ],
    supports_agent: [
      {
        key: "1",
        label: "dashboard",
        ActiveIcon: MdDashboard,
        InactiveIcon: MdOutlineDashboard,
        link: "/supporter/support-agent/dashboard",
        matchPaths: ["/supporter/support-agent/dashboard"],
      },
      {
        key: "2",
        label: "users",
        ActiveIcon: PiUsersThreeFill,
        InactiveIcon: PiUsersThreeBold,
        link: "/supporter/elderlies",
        matchPaths: [
          "/supporter/elderlies",
          "/supporter/elderlies/elderly-profile/*",
        ],
        innerPages: {
          "/elderly-profile/:id": "Elderly Profile",
        },
      },
      {
        key: "3",
        label: "notifications history",
        ActiveIcon: MdSdCardAlert,
        InactiveIcon: MdOutlineSdCardAlert,
        link: "/supporter/alerts",
        matchPaths: ["/supporter/alerts"],
      },
    ],
    nurse: [
      {
        key: "1",
        label: "dashboard",
        ActiveIcon: MdDashboard,
        InactiveIcon: MdOutlineDashboard,
        link: "/supporter/nurse/dashboard",
        matchPaths: ["/supporter/nurse/dashboard"],
      },
      {
        key: "2",
        label: "users",
        ActiveIcon: PiUsersThreeFill,
        InactiveIcon: PiUsersThreeBold,
        link: "/supporter/elderlies",
        matchPaths: [
          "/supporter/elderlies",
          "/supporter/elderlies/elderly-profile/*",
        ],
        innerPages: {
          "/elderly-profile/:id": "Elderly Profile",
        },
      },
      {
        key: "3",
        label: "notifications history",
        ActiveIcon: MdSdCardAlert,
        InactiveIcon: MdOutlineSdCardAlert,
        link: "/supporter/alerts",
        matchPaths: ["/supporter/alerts"],
      },
    ],
    end_user: [
      {
        key: "1",
        label: "dashboard",
        ActiveIcon: MdDashboard,
        InactiveIcon: MdOutlineDashboard,
        link: "/supporter/end-user/dashboard",
        matchPaths: ["/supporter/end-user/dashboard"],
      },
      {
        key: "2",
        label: "users",
        ActiveIcon: PiUsersThreeFill,
        InactiveIcon: PiUsersThreeBold,
        link: "/supporter/elderlies",
        matchPaths: [
          "/supporter/elderlies",
          "/supporter/elderlies/elderly-profile/*",
        ],
        innerPages: {
          "/elderly-profile/:id": "Elderly Profile",
        },
      },
      {
        key: "3",
        label: "notifications history",
        ActiveIcon: MdSdCardAlert,
        InactiveIcon: MdOutlineSdCardAlert,
        link: "/supporter/alerts",
        matchPaths: ["/supporter/alerts"],
      },
    ],
    monitoring_station: [
      {
        key: "1",
        label: "dashboard",
        ActiveIcon: MdDashboard,
        InactiveIcon: MdOutlineDashboard,
        link: "/support-nurnt/dashboard",
        matchPaths: ["/support-nurnt/dashboard"],
      },
      {
        key: "2",
        label: "users",
        ActiveIcon: PiUsersThreeFill,
        InactiveIcon: PiUsersThreeBold,
        link: "/support-nurnt/dashboard/suspended-user",
        matchPaths: ["/support-nurnt/dashboard/suspended-user"],
      },
      {
        key: "3",
        label: "orders",
        ActiveIcon: PiPackageFill,
        InactiveIcon: LuPackage,
        link: "/support-nurnt/dashboard/orders",
        matchPaths: ["/support-nurnt/dashboard/orders"],
      },
    ],
    distributor: [
      {
        key: "1",
        label: "dashboard",
        ActiveIcon: MdDashboard,
        InactiveIcon: MdOutlineDashboard,
        link: "/support-nurnt/dashboard",
        matchPaths: ["/support-nurnt/dashboard"],
      },
      {
        key: "2",
        label: "users",
        ActiveIcon: PiUsersThreeFill,
        InactiveIcon: PiUsersThreeBold,
        link: "/support-nurnt/dashboard/suspended-user",
        matchPaths: ["/support-nurnt/dashboard/suspended-user"],
      },
      {
        key: "3",
        label: "deals",
        ActiveIcon: PiPackageFill,
        InactiveIcon: LuPackage,
        link: "/support-nurnt/dashboard/deals",
        matchPaths: ["/support-nurnt/dashboard/deals"],
      },
    ],
    office: [
      {
        key: "1",
        label: "dashboard",
        ActiveIcon: MdDashboard,
        InactiveIcon: MdOutlineDashboard,
        link: "/support-nurnt/dashboard",
        matchPaths: ["/support-nurnt/dashboard"],
      },
      {
        key: "2",
        label: "users",
        ActiveIcon: PiUsersThreeFill,
        InactiveIcon: PiUsersThreeBold,
        link: "/support-nurnt/dashboard/suspended-user",
        matchPaths: ["/support-nurnt/dashboard/suspended-user"],
      },
      {
        key: "3",
        label: "deals",
        ActiveIcon: PiPackageFill,
        InactiveIcon: LuPackage,
        link: "/support-nurnt/dashboard/deals",
        matchPaths: ["/support-nurnt/dashboard/deals"],
      },
    ],
    installer: [
      {
        key: "1",
        label: "dashboard",
        ActiveIcon: MdDashboard,
        InactiveIcon: MdOutlineDashboard,
        link: "/support-nurnt/dashboard",
        matchPaths: ["/support-nurnt/dashboard"],
      },
      {
        key: "2",
        label: "installation",
        ActiveIcon: AiFillTool,
        InactiveIcon: AiOutlineTool,
        link: "/support-nurnt/dashboard/installation",
        matchPaths: ["/support-nurnt/dashboard/installation"],
      },
    ],
    others: [
      {
        key: "1",
        label: "dashboard",
        ActiveIcon: MdDashboard,
        InactiveIcon: MdOutlineDashboard,
        link: "/support-nurnt/dashboard",
        matchPaths: ["/support-nurnt/dashboard"],
      },
      {
        key: "2",
        label: "users",
        ActiveIcon: PiUsersThreeFill,
        InactiveIcon: PiUsersThreeBold,
        link: "/support-nurnt/dashboard/suspended-user",
        matchPaths: ["/support-nurnt/dashboard/suspended-user"],
      },
    ],
  };
  useEffect(() => {
    const currentRoleNav = NAV_CONFIG[user.role] || NAV_CONFIG.others;
    let foundParent = null;
    // Check all navigation items for inner page matches
    currentRoleNav.forEach((item) => {
      if (item.innerPages) {
        Object.keys(item.innerPages).forEach((pathPattern) => {
          const fullPath = `${item.link}${pathPattern}`
            .replace(/\/\//g, "/") // Remove double slashes
            .replace(/:\w+/g, "[^/]+") // Handle parameters
            .replace(/\*/g, ".*"); // Handle wildcards

          const regex = new RegExp(`^${fullPath}$`, "i");
          if (regex.test(currentPath)) {
            foundParent = item?.innerPages[pathPattern];
          }
        });
      }
    });

    if (foundParent) {
      setActiveMenu(foundParent);
      return;
    }

    // Finally check regular paths
    const activeItem = currentRoleNav.find((item) =>
      item.matchPaths.some((path) => {
        const regexReadyPath = path
          .replace(/\*/g, ".*")
          .replace(/:\w+/g, "[^/]+");

        const regex = new RegExp(`^${regexReadyPath}$`, "i");
        return regex.test(currentPath);
      })
    );

    setActiveMenu(activeItem?.label || currentRoleNav[0]?.label);
    setElderlyDetails(ls.get("elderly_details"));
  }, [currentPath, user.role]);

  useEffect(() => {
    getUsers();
    setElderlyDetails(ls.get("elderly_details"));
  }, [currentPath]);
  const getRecentlyDeletedUsers = useCallback(() => {
    if (!toggleMainSidebar) return;
    setLoading(true);
    getDeletedUser({ ...query, ...page }).then((res) => {
      if (res) {
        setRecentlyDeletedUsers(res.data);
        SetTotal(res.total);
        setLoading(false);
      }
    });
  }, [query, toggleMainSidebar, page]);

  useEffect(() => {
    if (!currentPath?.includes("/supporter/elderlies/elderly-profile/")) {
      const deviceCode = ls.get("elderly_details")?.deviceId;

      if (deviceCode) {
        const deviceCodesArray = deviceCode.split(",");
        deviceCodesArray.forEach((deviceNo) => {
          unsubscribeFromMqtt({
            uid: deviceNo,
            messageType: ["1", "2", "3", "4"],
          })
            .then((res) => {
              // Handle the response if needed
            })
            .catch((err) => {
              console.log(
                `Error unsubscribing for Device No ${deviceNo}:`,
                err
              );
            });
        });
      }
    }
  }, [currentPath]);

  function isTokenValid() {
    const tokenData = JSON.parse(localStorage.getItem("tokenData"));
    if (!tokenData) return null;

    const currentTime = Date.now();
    if (currentTime < tokenData.expiry) {
      return tokenData;
    }

    return null;
  }

  const defaultDevice = elderlyDetails?.rooms?.find((room) => room.device_no);
  const dropdownItems = elderlyDetails?.rooms
    ?.filter(
      (room) => room.device_no && room.device_no !== defaultDevice?.device_no
    )
    .map((room) => ({
      label: room.name,
      key: room.device_no,
    }));

  const onChange = (date, dateString) => {
    // console.log(dateString);
    setDailyRepDate(dateString);
  };
  const handleCall = (id) => {
    if (id) {
      getTokenToMakeCall(id);
    }
  };
  function getTokenToMakeCall(id) {
    const storedToken = isTokenValid();
    if (storedToken) {
      // Token is still valid, use it to make the call
      makeACall(id, storedToken.accessToken, storedToken.refreshToken);
    } else {
      getTokenToCall()
        .then((token) => {
          const accessToken = token?.data?.access_token;
          const refreshToken = token?.data?.refresh_token;
          const expiryTime = Date.now() + 3600 * 1000; // Set expiry time to 1 hour

          // Store the new token and expiry time in localStorage
          localStorage.setItem(
            "tokenData",
            JSON.stringify({
              accessToken,
              refreshToken,
              expiry: expiryTime,
            })
          );

          makeACall(id, accessToken, refreshToken);
        })
        .catch((error) => {
          console.error("Error fetching token:", error);
        });
    }
  }
  function makeACall(uid, accessToken, refreshToken) {
    openPopup(uid, accessToken, refreshToken);
  }
  function openPopup(uid, accessToken, refreshToken) {
    const data = {
      uid: uid,
      token: accessToken,
      freshToken: refreshToken,
      lang: "en_US",
    };

    const popupUrl = `https://console.elderlycareplatform.com/metting?${new URLSearchParams(
      data
    ).toString()}`;

    // Window features for customization
    const windowFeatures =
      "width=500,height=600,scrollbars=no,resizable=no,location=no,toolbar=no,status=no,menubar=no";

    // Open the window with the custom features
    const popup = window.open(popupUrl, "Device Calling", windowFeatures);

    if (popup) {
      popup.focus(); // Focus on the new popup window
    } else {
      console.error("Popup window could not be opened");
    }
  }
  const handleClick = (key, item) => {
    navigate(item.link);
  };

  const handleSidebarClose = () => {
    setToggleSidebar(!toggleSidebar);
    if (toggleMainSidebar) {
      setToggleMainSidebar(false);
    }
  };

  const handleRecentlyDeleted = () => {
    if (toggleMainSidebar) {
      // If recently deleted sidebar is open, close both sidebars
      setToggleSidebar(true);
      setToggleMainSidebar(false);
    } else {
      // If recently deleted sidebar is closed, open it and close the main sidebar
      setToggleSidebar(false);
      setToggleMainSidebar(true);
    }
  };

  const handleCloseRecentlyDeleted = () => {
    setToggleSidebar(true);
    setToggleMainSidebar(false);
  };
  //handle Logout
  const handelLogout = () => {
    removeToken();
    navigate("/");
  };

  const handBlurchange = () => {
    setQuey({ ...query, search: search.trim() });
    SetPage({ ...page, page: 1 });
  };

  useEffect(() => {
    if (selected && query.orderType != selected) {
      delete query.sort_by_created_at;
      delete query.sort_by_name;
      setQuey({
        ...(selected === "Name"
          ? { sort_by_name: 1 }
          : { sort_by_created_at: 1 }),
      });
      SetPage({ ...page, page: 1 });
    }
  }, [selected]);
  useEffect(() => {
    if (selectedRole && selectedRole !== "All Users") {
      setQuey({
        ...query,
        role: RoleMapping[selectedRole],
      });

      SetPage({ ...page, page: 1 });
    } else {
      delete query.role;
      setQuey({
        ...query,
      });
      SetPage({ ...page, page: 1 });
    }
  }, [selectedRole]);
  useEffect(() => {
    getRecentlyDeletedUsers();
  }, [getRecentlyDeletedUsers]);
  const nvto = (active) => {
    if (active == "super_admin") {
      navigate("/super-admin/users");
    } else {
      navigate("/support-nurnt/dashboard/suspended-user");
    }
  };
  // Restore the original token when switching back
  const restoreOriginalToken = () => {
    const originalToken = ls.get("rootToken");
    if (originalToken) {
      setToken(originalToken); // Restore the original token
      ls.remove("rootToken"); // Clear the stored original token once done
    }
  };
  function handleRoleBack() {
    restoreOriginalToken();
    setLoader(true);
    const token = getToken() || ls.get("rootToken");
    const data = jwtDecode(token);
    // setMainRole(data?.role);
    ls.set("user", data);
    ls.set("mainRole", data.role);
    ls.set("role", data.role);
    setStoreRole({ role: data.role });
    setUser({ role: data.role });

    setTimeout(() => {
      setLoader(false);
      nvto(data?.role);
    }, 1500);
  }
  return (
    <>
      <Layout className="overflow-hidden">
        <Sider
          breakpoint="lg"
          collapsedWidth="0"
          width="120"
          onCollapse={(collapsed) => setToggleMainSidebar(collapsed)}
          collapsed={toggleMainSidebar}
        >
          <img
            src={sidebarlogo}
            className="demo-logo-vertical"
            alt="sidebar-logo"
          />

          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={[activeMemu]}
            inlineCollapsed={false}
          >
            {(NAV_CONFIG[user.role] || NAV_CONFIG.others).map((item) => (
              <Menu.Item
                key={item.key}
                icon={
                  activeMemu === item.label ? (
                    <item.ActiveIcon size={25} />
                  ) : (
                    <item.InactiveIcon size={25} />
                  )
                }
                onClick={() => {
                  handleClick(item.key, item);
                  // setActiveMenu(item.label);
                }}
              >
                <NavLink
                  to={item.link}
                  exact="true"
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  {item.label}
                </NavLink>
              </Menu.Item>
            ))}
          </Menu>

          {rootRole === "super_admin" && mainRole !== "super_admin" && (
            <div
              className="absolute text-white bottom-10 text-base font-semibold text-center cursor-pointer w-full"
              onClick={handleRoleBack}
            >
              Go Back
            </div>
          )}
        </Sider>
        <Layout
          style={{
            height: "100vh",
            padding: "0px !importent",
            position: "relative",
          }}
        >
          <Header
            style={{
              background: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              fontFamily: "Baloo2",
              // padding: "20px",
              height: "100px",
              paddingLeft: "30px",
              paddingRight: "30px",
              position: "relative",
            }}
          >
            <h1 className="text-text-primary text-[28px] font-semibold capitalize leading-0">
              {activeMemu}
            </h1>

            {userData &&
              !currentPath?.includes(
                "/supporter/elderlies/elderly-profile/"
              ) && (
                <div
                  className="flex items-center gap-3 cursor-pointer"
                  onClick={handleSidebarClose}
                >
                  <div className="flex flex-col items-end justify-start">
                    <p className="leading-[0.98] font-bold text-xl text-primary">
                      {userData && userData.last_name
                        ? `${userData.name} ${userData.last_name}`
                        : userData.name}
                    </p>
                    <span className="leading-1 font-medium text-sm text-text-secondary">
                      {rolesFormatter[userData.role]}
                    </span>
                  </div>
                  <div className="h-[42px] w-[42px] bg-[#80CAA7] flex items-center justify-center text-white font-bold text-lg rounded-full">
                    <p>
                      {userData && userData.last_name
                        ? `${userData.name
                            .charAt(0)
                            .toUpperCase()} ${userData.last_name
                            .charAt(0)
                            .toUpperCase()}`
                        : userData.name.slice(0, 2).toUpperCase()}
                    </p>
                  </div>
                </div>
              )}
            {currentPath?.includes("/supporter/elderlies/elderly-profile/") && (
              <div className="flex items-center gap-3 cursor-pointer">
                {/* <Dropdown.Button
                  menu={{
                    items: [
                      {
                        label: "Call 911",
                        key: "1",
                      },
                      {
                        label: "Call Caregiver",
                        key: "2",
                      },
                    ],
                    onClick: () => {
                      console.log("clicked");
                    },
                  }}
                  size="large"
                >
                  <LuPhoneCall />
                  Call Elderly
                </Dropdown.Button> */}
                <DatePicker
                  size="large"
                  onChange={onChange}
                  placeholder="Today Report"
                  style={{ width: "220px" }}
                />
                {elderlyDetails && (
                  <Dropdown.Button
                    style={{ width: "fit-content" }}
                    menu={{
                      items: dropdownItems,
                      onClick: ({ key }) => handleCall(key),
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (defaultDevice?.device_no) {
                        handleCall(defaultDevice.device_no);
                      }
                    }}
                    size="large"
                  >
                    <LuPhoneCall />
                    {`Call To ${defaultDevice?.name || "Device"}`}{" "}
                    {/* Default room with device_no */}
                  </Dropdown.Button>
                )}
              </div>
            )}
          </Header>
          <Content
            style={{
              padding: "0px 30px 0px 30px",
              fontFamily: "Baloo2",
              background: "#F1F5F9",
              overflow: "auto",
            }}
          >
            {loader ? <Loader loaderTitle="Going Back" /> : null}
            <Outlet></Outlet>
          </Content>
        </Layout>
        {userData ? (
          <Sider
            collapsed={toggleSidebar}
            collapsedWidth={0}
            width={toggleMainSidebar ? "100%" : 360}
            style={{
              background: "#fff",
              fontFamily: "Baloo2",
              zIndex: 1000,
            }}
            className="transition-all duration-500 h-[100vh] overflow-x-hidden overflow-y-auto border-none"
          >
            <div
              className={`${
                toggleMainSidebar ? "flex" : "block"
              } overflow-hidden border-none`}
            >
              <div
                className={`${
                  toggleMainSidebar ? "w-[38%]" : "w-[100%]"
                } h-[100vh] p-4 flex flex-col gap-7 border border-r-2 overflow-y-auto border-[#EBEBEE0]`}
              >
                <div
                  className={`p-2 text-text-secondary hover:text-text-primary cursor-pointer  w-fit `}
                  onClick={handleCloseRecentlyDeleted}
                >
                  <LuPanelRightClose size={24} />
                </div>
                <div className="flex flex-col items-center gap-3">
                  <div className="h-[95px] w-[95px] bg-[#80CAA7] flex items-center justify-center text-white font-bold text-4xl rounded-full">
                    <p>
                      {userData && userData.last_name
                        ? `${userData.name
                            .charAt(0)
                            .toUpperCase()} ${userData.last_name
                            .charAt(0)
                            .toUpperCase()}`
                        : userData.name.slice(0, 2).toUpperCase()}
                    </p>
                  </div>
                  <div className="flex flex-col items-center justify-center text-center">
                    <p className="leading-[0.98] font-bold text-[24px] text-primary">
                      {userData && userData.last_name
                        ? `${userData.name} ${userData.last_name}`
                        : userData.name}
                    </p>
                    <span className="leading-1 font-medium text-base text-text-secondary">
                      {rolesFormatter[userData.role]}
                    </span>
                  </div>
                </div>
                <div>
                  <ul className="flex flex-col gap-6">
                    {userData.agent_id && userData.role == "sales_agent" ? (
                      <li className="flex flex-col gap-1">
                        <span className="text-sm font-semibold text-text-secondary">
                          Agent ID
                        </span>
                        <p className="text-[18px] leading-[0.8] font-normal text-text-primary text-wrap">
                          {userData.agent_id}
                        </p>
                      </li>
                    ) : null}
                    {userData.email ? (
                      <li className="flex flex-col gap-1">
                        <span className="text-sm font-semibold text-text-secondary">
                          Email
                        </span>
                        <p className="text-[18px] leading-[0.8] font-normal text-text-primary text-wrap">
                          {userData.email}
                        </p>
                      </li>
                    ) : null}
                    {userData.contact_number ? (
                      <li className="flex flex-col gap-1">
                        <span className="text-sm font-semibold text-text-secondary">
                          Contact Number
                        </span>
                        <p className="text-[18px] leading-[0.8] font-normal text-text-primary text-wrap">
                          {userData.contact_number}
                        </p>
                      </li>
                    ) : null}
                    {userData.address ? (
                      <li className="flex flex-col gap-1">
                        <span className="text-sm font-semibold text-text-secondary">
                          Address
                        </span>
                        <p className="text-[18px] leading-[0.8] font-normal text-text-primary text-wrap">
                          {userData.address}
                        </p>
                      </li>
                    ) : null}
                  </ul>
                </div>

                <div className="flex flex-col gap-3">
                  <div className="flex items-center gap-2">
                    <span className="text-primary font-bold">MENU</span>
                    <hr className="h-[2px] w-full bg-[#D8D9DE]" />
                  </div>

                  <ul className="flex flex-col gap-4">
                    <li
                      className="flex justify-between items-center group cursor-pointer"
                      onClick={() => setEdit(true)}
                    >
                      <div className="flex items-center gap-4">
                        <div className="text-[#4356FD] w-[45px] h-[45px] bg-[#4356FD]/10 flex items-center justify-center rounded-[50px] transition-all duration-300 ease-in-out group-hover:rounded-xl group-hover:bg-[#4356FD] group-hover:text-white">
                          <LuPencil size={20} />
                        </div>
                        <p className="text-[18px] text-text-primary">
                          Change Profile
                        </p>
                      </div>
                      <div className="relative w-[24px] h-[24px] text-text-primary/5 transition-transform duration-300 ease-in-out group-hover:translate-x-[5px] bg-[#4356FD]/10 flex items-center justify-center rounded-full">
                        <LuChevronRight
                          className="text-text-primary/60"
                          size={18}
                        />
                      </div>
                    </li>
                    <li
                      className="flex justify-between items-center group cursor-pointer"
                      onClick={() => setResetMOdal(true)}
                    >
                      <div className="flex items-center gap-4">
                        <div className="text-[#DBAF00] w-[45px] h-[45px] bg-[#DBAF00]/10 flex items-center justify-center rounded-[50px] transition-all duration-300 ease-in-out group-hover:rounded-xl group-hover:bg-[#DBAF00] group-hover:text-white">
                          <LuKeyRound size={20} />
                        </div>
                        <p className="text-[18px] text-text-primary">
                          Reset Password
                        </p>
                      </div>
                      <div className="relative w-[24px] h-[24px] text-text-primary/5 transition-transform duration-300 ease-in-out group-hover:translate-x-[5px] bg-[#4356FD]/10 flex items-center justify-center rounded-full">
                        <LuChevronRight
                          className="text-text-primary/60"
                          size={18}
                        />
                      </div>
                    </li>
                    <li
                      className="flex justify-between items-center group cursor-pointer"
                      onClick={handleRecentlyDeleted}
                    >
                      <div className="flex items-center gap-4">
                        <div
                          className={`${
                            toggleMainSidebar
                              ? "text-[#fff] bg-[#DB2100] rounded-xl"
                              : "text-[#DB2100] bg-[#DB2100]/10 rounded-[50px]"
                          } w-[45px] h-[45px]  flex items-center justify-center rounded-[50px] transition-all duration-300 ease-in-out group-hover:rounded-xl group-hover:bg-[#DB2100] group-hover:text-white`}
                        >
                          <LuTrash size={20} />
                        </div>
                        <p className="text-[18px] text-text-primary">
                          Recently Deleted
                        </p>
                      </div>
                      <div className="relative w-[24px] h-[24px] text-text-primary/5 transition-transform duration-300 ease-in-out group-hover:translate-x-[5px] bg-[#4356FD]/10 flex items-center justify-center rounded-full">
                        <LuChevronRight
                          className="text-text-primary/60"
                          size={18}
                        />
                      </div>
                    </li>
                    <li
                      onClick={() => setShow(true)}
                      className="flex justify-between items-center group cursor-pointer"
                    >
                      <div className="flex items-center gap-4">
                        <div className="text-[#333951] w-[45px] h-[45px] bg-[#333951]/10 flex items-center justify-center rounded-[50px] transition-all duration-300 ease-in-out group-hover:rounded-xl group-hover:bg-[#333951] group-hover:text-white">
                          <LuLogOut size={20} />
                        </div>
                        <p className="text-[18px] text-text-primary">Log Out</p>
                      </div>
                      <div className="relative w-[24px] h-[24px] text-text-primary/5 transition-transform duration-300 ease-in-out group-hover:translate-x-[5px] bg-[#4356FD]/10 flex items-center justify-center rounded-full">
                        <LuChevronRight
                          className="text-text-primary"
                          size={18}
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              {toggleMainSidebar ? (
                <div
                  className={`w-full transition-all duration-500 pb-10 h-[100vh] overflow-auto`}
                >
                  <div>
                    <div className=" bg-white rounded-2xl ">
                      <div className=" px-[22px] py-6 flex items-center flex-col lg:flex-row justify-between gap-2 ">
                        <div className=" flex items-center justify-between w-full">
                          <h2 className=" text-2xl font-bold text-text-primary">
                            Recently Deleted Users
                          </h2>
                        </div>
                        <div className=" flex items-center justify-end gap-5 w-full">
                          {/* =====Search sort and add admin button===== */}
                          <SearchInput
                            search={search}
                            setSearch={setSearch}
                            handBlurchange={handBlurchange}
                            placeholder="Search User"
                          />
                          <RoleSort
                            selectedRole={selectedRole}
                            setSelectedRole={setSelectedRole}
                            data={RoleBaseSortItem.super_admin}
                          />
                          <Sort
                            query={query}
                            setQuery={setQuey}
                            selected={selected}
                            setSelected={setSelected}
                            data={data}
                          />
                        </div>
                      </div>
                    </div>

                    <div className=" grid grid-cols-1">
                      <SidebarContext1.SidebarContext.Provider
                        value={{
                          role: query.role,
                          getlist: getRecentlyDeletedUsers,
                          query,
                          total,
                          page,
                          SetPage,
                        }}
                      >
                        <AdminSupportAgentTable
                          loading={loading}
                          tableData={recentlyDeletedUsers}
                          columns={deletedUserColumns}
                          getlist={getRecentlyDeletedUsers}
                        />
                      </SidebarContext1.SidebarContext.Provider>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </Sider>
        ) : null}
      </Layout>
      <CreateAdminSupportAgent
        item={userData}
        role={userData?.role}
        getlist={getUsers}
        modalOPen={edit}
        ownEdit={true}
        setModalOpen={setEdit}
        isEditMode={edit}
      />
      <ChnaePasswordModal
        item={userData}
        modalOPen={resetModal}
        setModalOpen={setResetMOdal}
      />

      <LogOutModal
        modalOPen={show}
        setModalOpen={setShow}
        onDelete={handelLogout}
      />
    </>
  );
};

export default DashboardLayout;
